import { isNil } from "lodash";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  copyDriverDayEdit,
  editDriver,
  setHideDriverManagementModal,
} from "../../../reducers/driverManagement/thunkActions";
import { driverEditModeSelector } from "../../../reducers/driverManagement/selectors";

import { Modal } from "../Modal";
import { CopyDriverWorkScheduleContent } from "./CopyDriverWorkScheduleContent";
import { CopyDriverWorkScheduleActions } from "./CopyDriverWorkScheduleActions";

export const CopyDriverWorkScheduleModal = ({ onClose, driver }) => {
  const dispatch = useDispatch();
  const driverEditMode = useSelector(driverEditModeSelector);
  const [sourceDayOfWeek, setSourceDayOfWeek] = useState(null);
  const [targetDaysOfWeek, setTargetDaysOfWeek] = useState({
    1: false,
    2: false,
    3: false,
    4: false,
    5: false,
    6: false,
    0: false,
  });

  const disable =
    isNil(sourceDayOfWeek) ||
    !Object.values(targetDaysOfWeek).find((dayOfWeek) => !!dayOfWeek);

  const onContinue = async () => {
    let error;
    if (!driverEditMode) ({ error } = await dispatch(editDriver(driver)));
    if (error) return;

    for (const [dayOfWeek, value] of Object.entries(targetDaysOfWeek)) {
      if (!value || error) continue;
      ({ error } = await dispatch(
        copyDriverDayEdit({ sourceDayOfWeek, targetDayOfWeek: dayOfWeek })
      ));
    }
    !error && onClose();
  };

  useEffect(() => {
    dispatch(setHideDriverManagementModal(true));
    return () => dispatch(setHideDriverManagementModal(false));
  }, [dispatch]);

  return (
    <Modal
      open={true}
      onClose={onClose}
      title={"Copy Driver Work Schedule"}
      content={
        <CopyDriverWorkScheduleContent
          sourceDayOfWeek={sourceDayOfWeek}
          targetDaysOfWeek={targetDaysOfWeek}
          onSourceDayChange={setSourceDayOfWeek}
          onTargetDayChange={setTargetDaysOfWeek}
        />
      }
      actions={
        <CopyDriverWorkScheduleActions
          disable={disable}
          onCancel={onClose}
          onContinue={onContinue}
        />
      }
      maxWidth={"sm"}
    />
  );
};
